import React from 'react';
import { Link } from 'react-router-dom';

import { DisplayPercent, PercentBar, CountryFlagRounded } from '../';

import { previewCategories } from '../../tools/templateTools';

import { CALCULATION_URL } from '../../views/innerURLs';

import './previewcard.css';


const PreviewCard = ({ calc }) => {
  // console.log('PreviewCard - calc', calc);
  const { country, fit, _id } = calc;
  let { categories } = calc;



  categories = previewCategories(categories);


  const catsHtml = categories.map((cat, index) => {
    const { category, fit } = cat;


    return <PercentBar key={'cat_' + index} name={category} percent={fit} />

    // return <h4 style={style} className={"preview-card-bottom-cat"} key={'cat_'+index}>{name} 
    //   <DisplayPercent percent={fit} />
    // </h4>
  });


  const flagDisplay = <CountryFlagRounded countryData={[country]} />

  // <div className="preview-card-top-flag"></div>

  return (
    <div className="preview-card">
      <div className="preview-card-top">
        {flagDisplay}
        <h2 className={"preview-card-top-flag-fit"}><DisplayPercent percent={fit} /></h2>
        <h3 className="preview-card-top-flag-country-name">{country}</h3>
      </div>

      <div className="preview-card-bottom">
        <div>{catsHtml}</div>

        <Link to={CALCULATION_URL + '/' + _id} className="full-analysis">See Full Analysis</Link>
      </div>
    </div>
  )
}

export default PreviewCard;